<template>
  <div class="notice-management">
    <!-- 页面头部 -->
    <div class="page-header">
      <h2>公告管理</h2>
      <p class="page-desc">向指定徒步人群发布活动通知、行程提醒与平台公告。</p>
      <el-button type="primary" @click="handleCreate">
        <i class="el-icon-plus"></i> 新增公告
      </el-button>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-cards" v-if="false">
      <div class="stat-card">
        <div class="stat-icon all">
          <i class="el-icon-notebook-2"></i>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ stats.total }}</div>
          <div class="stat-label">公告总数</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon published">
          <i class="el-icon-success"></i>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ stats.published }}</div>
          <div class="stat-label">已发布</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon draft">
          <i class="el-icon-edit-outline"></i>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ stats.draft }}</div>
          <div class="stat-label">草稿箱</div>
        </div>
      </div>
    </div>

    <!-- 列表区域 -->
    <div class="list-section">
      <div class="list-header">
        <h3>公告列表</h3>
        <div class="search-area">
          <el-input
            v-model="searchKeyword"
            placeholder="搜索公告标题"
            prefix-icon="el-icon-search"
            clearable
            style="width: 200px; margin-right: 12px"
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          />
          <el-select
            v-model="searchStatus"
            placeholder="发布状态"
            clearable
            style="width: 120px; margin-right: 12px"
            @change="handleSearch"
          >
            <el-option label="草稿" value="0"></el-option>
            <el-option label="已发布" value="1"></el-option>
            <el-option label="已下线" value="2"></el-option>
          </el-select>
          <el-select
            v-model="searchTargetAudience"
            placeholder="目标人群"
            clearable
            style="width: 130px; margin-right: 12px"
            @change="handleSearch"
          >
            <el-option label="全部用户" value="0"></el-option>
            <el-option label="普通会员" value="1"></el-option>
            <el-option label="领队" value="2"></el-option>
            <el-option label="分销商" value="3"></el-option>
          </el-select>
          <el-date-picker
            v-model="searchDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 380px; margin-right: 12px"
            @change="handleSearch"
          />
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>
        </div>
      </div>

      <el-table :data="list" style="width: 100%" v-loading="loading" border>
        <el-table-column label="公告标题" min-width="250">
          <template slot-scope="scope">
            <div class="notice-title">{{ scope.row.title }}</div>
            <div class="notice-content-preview">
              {{ scope.row.contentText }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="公告人群" width="100">
          <template slot-scope="scope">
            <el-tag
              v-for="(item, index) in getTargetAudienceList(
                scope.row.targetAudience
              )"
              :key="index"
              :type="getTagType(item)"
              size="mini"
              style="margin-right: 4px"
            >
              {{ item }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发布状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.updateTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="发布时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.publishTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="发布人" width="120">
          <template slot-scope="scope">
            {{ scope.row.publishAdminName }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 0 && scope.row.publishTime"
              type="text"
              @click="handlePublishNow(scope.row)"
            >
              立即发布
            </el-button>
            <el-button
              v-if="scope.row.status === 1"
              type="text"
              @click="handleOffline(scope.row)"
            >
              下线
            </el-button>
            <el-button type="text" @click="handleView(scope.row)"
              >查看</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.status === 0"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <span class="pagination-info">
          显示第 {{ (currentPage - 1) * pageSize + 1 }} 至
          {{ currentPage * pageSize > total ? total : currentPage * pageSize }}
          条，共 {{ total }} 条记录
        </span>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="fetchList"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoticeManagement',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchKeyword: '',
      searchStatus: '',
      searchTargetAudience: '',
      searchDateRange: [],
      stats: {
        total: 0,
        published: 0,
        draft: 0
      }
    }
  },
  watch: {
    searchDateRange: {
      handler() {
        this.saveSearchState()
      },
      deep: true
    }
  },
  mounted() {
    this.loadSearchState()
    this.fetchList()
    this.fetchStats()
  },
  watch: {
    searchKeyword() {
      this.saveSearchState()
    },
    searchStatus() {
      this.saveSearchState()
    },
    searchTargetAudience() {
      this.saveSearchState()
    },
    searchDateRange() {
      this.saveSearchState()
    },
    currentPage() {
      this.saveSearchState()
    }
  },
  methods: {
    // 保存搜索状态到sessionStorage
    saveSearchState() {
      const state = {
        searchKeyword: this.searchKeyword,
        searchStatus: this.searchStatus,
        searchTargetAudience: this.searchTargetAudience,
        searchDateRange: this.searchDateRange,
        currentPage: this.currentPage
      }
      sessionStorage.setItem('notice_search_state', JSON.stringify(state))
    },
    // 从sessionStorage恢复搜索状态
    loadSearchState() {
      const saved = sessionStorage.getItem('notice_search_state')
      if (saved) {
        try {
          const state = JSON.parse(saved)
          this.searchKeyword = state.searchKeyword || ''
          this.searchStatus = state.searchStatus || ''
          this.searchTargetAudience = state.searchTargetAudience || ''
          this.searchDateRange = state.searchDateRange || []
          this.currentPage = state.currentPage || 1
        } catch (e) {
          console.error('恢复搜索状态失败:', e)
        }
      }
    },
    // 获取统计数据
    async fetchStats() {
      try {
        const res = await this.$http.post('notice/getNoticeList.do', {
          pageNum: 1,
          pageSize: 1
        })
        if (res.code === '0' || res.code === 0) {
          this.stats.total = res.total || 0
        }
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
      // 分别获取已发布和草稿数量
      try {
        const [pubRes, draftRes] = await Promise.all([
          this.$http.post('notice/getNoticeList.do', {
            pageNum: 1,
            pageSize: 1,
            status: 1
          }),
          this.$http.post('notice/getNoticeList.do', {
            pageNum: 1,
            pageSize: 1,
            status: 0
          })
        ])
        if (pubRes.code === '0' || pubRes.code === 0) {
          this.stats.published = pubRes.total || 0
        }
        if (draftRes.code === '0' || draftRes.code === 0) {
          this.stats.draft = draftRes.total || 0
        }
      } catch (error) {
        console.error('获取统计详情失败:', error)
      }
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.fetchList()
    },

    // 重置
    handleReset() {
      this.searchKeyword = ''
      this.searchStatus = ''
      this.searchTargetAudience = ''
      this.searchDateRange = []
      this.currentPage = 1
      this.fetchList()
    },

    // 获取列表
    async fetchList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
        if (this.searchKeyword) {
          params.title = this.searchKeyword
        }
        if (this.searchStatus !== '') {
          params.status = this.searchStatus
        }
        if (this.searchTargetAudience !== '') {
          params.targetAudience = this.searchTargetAudience
        }
        if (this.searchDateRange && this.searchDateRange.length === 2) {
          params.startTime = this.searchDateRange[0] + ' 00:00:00'
          params.endTime = this.searchDateRange[1] + ' 23:59:59'
        }
        const res = await this.$http.post('notice/getNoticeList.do', params)
        if (res.code === '0' || res.code === 0) {
          this.list = res.result || []
          this.total = res.total || 0
        } else {
          this.$message.error(res.message || '获取公告列表失败')
        }
      } catch (error) {
        console.error('获取公告列表失败:', error)
        this.$message.error('网络请求异常')
      } finally {
        this.loading = false
      }
    },

    // 显示目标人群标签
    getTargetAudienceList(targetAudience) {
      if (!targetAudience && targetAudience !== 0) return []
      const targetMap = {
        0: '全部用户',
        1: '普通会员',
        2: '领队',
        3: '分销商'
      }
      // 如果是数组
      if (Array.isArray(targetAudience)) {
        return targetAudience.map((t) => targetMap[t]).filter(Boolean)
      }
      // 如果是字符串（如 "1,2,3"）
      if (typeof targetAudience === 'string') {
        return targetAudience
          .split(',')
          .map((t) => targetMap[Number(t)])
          .filter(Boolean)
      }
      // 单个值
      if (targetMap[targetAudience]) {
        return [targetMap[targetAudience]]
      }
      return []
    },

    // 获取标签颜色
    getTagType(label) {
      const typeMap = {
        领队: 'warning',
        普通会员: 'success',
        分销商: 'info',
        全部用户: ''
      }
      return typeMap[label] || ''
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = { 0: '草稿', 1: '已发布', 2: '已下线' }
      return statusMap[status] || '未知'
    },

    // 获取状态类型
    getStatusType(status) {
      const typeMap = { 0: 'info', 1: 'success', 2: 'warning' }
      return typeMap[status] || ''
    },

    // 新增
    handleCreate() {
      this.$router.push('/notice/create')
    },

    // 编辑
    handleEdit(row) {
      this.$router.push(`/notice/edit/${row.id}`)
    },

    // 查看详情
    handleView(row) {
      this.$router.push(`/notice/detail/${row.id}`)
    },

    // 立即发布
    handlePublishNow(row) {
      this.$confirm('确定要立即发布该公告吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const res = await this.$http.post('notice/publishNow.do', {
              id: row.id
            })
            if (res.code === '0' || res.code === 0) {
              this.$message.success('发布成功')
              this.fetchList()
              this.fetchStats()
            } else {
              this.$message.error(res.message || '发布失败')
            }
          } catch (error) {
            this.$message.error('网络请求异常')
          }
        })
        .catch(() => {})
    },

    // 下线
    handleOffline(row) {
      this.$confirm('确定要下线该公告吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const res = await this.$http.post('notice/offlineNotice.do', {
              id: row.id
            })
            if (res.code === '0' || res.code === 0) {
              this.$message.success('下线成功')
              this.fetchList()
              this.fetchStats()
            } else {
              this.$message.error(res.message || '下线失败')
            }
          } catch (error) {
            this.$message.error('网络请求异常')
          }
        })
        .catch(() => {})
    },

    // 删除
    handleDelete(row) {
      this.$confirm('确定要删除该公告吗？删除后不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger'
      })
        .then(async () => {
          try {
            const res = await this.$http.post('notice/deleteNotice.do', {
              id: row.id
            })
            if (res.code === '0' || res.code === 0) {
              this.$message.success('删除成功')
              this.fetchList()
              this.fetchStats()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          } catch (error) {
            this.$message.error('网络请求异常')
          }
        })
        .catch(() => {})
    }
  },
  filters: {
    formatDate(value) {
      if (value === null || value === undefined || value === '') return '-'
      // 如果是数字（毫秒时间戳）
      if (typeof value === 'number' || /^\d+$/.test(String(value))) {
        const numValue = typeof value === 'number' ? value : Number(value)
        const date = new Date(numValue)
        if (isNaN(date.getTime())) return '-'
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        return `${year}-${month}-${day} ${hours}:${minutes}`
      }
      // 如果是字符串日期格式
      if (typeof value === 'string') {
        // 尝试解析为数字
        if (/^\d+$/.test(value.trim())) {
          const date = new Date(Number(value))
          if (!isNaN(date.getTime())) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            return `${year}-${month}-${day} ${hours}:${minutes}`
          }
        }
        // 普通字符串日期
        return value.replace('T', ' ').substring(0, 16)
      }
      return '-'
    }
  }
}
</script>

<style scoped>
.notice-management {
  padding: 20px 24px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 80px);
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.page-desc {
  margin: 8px 0 16px;
  font-size: 14px;
  color: #6b7280;
}

.page-header .el-button {
  float: right;
  margin-top: -40px;
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  border: none;
}

.stats-cards {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  flex: 1;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.stat-icon.all {
  background: #f0f9ff;
  color: #3b82f6;
}

.stat-icon.published {
  background: #f0fdf4;
  color: #22c55e;
}

.stat-icon.draft {
  background: #fffbeb;
  color: #f59e0b;
}

.stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
}

.stat-label {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
}

.list-section {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.list-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.notice-title {
  font-weight: 500;
  color: #1f2937;
}

.notice-content-preview {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0 0;
  margin-top: 16px;
}

.pagination-info {
  font-size: 13px;
  color: #6b7280;
}
</style>
